import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "layout" */ '../components/layout/Layout.vue'),
    redirect: '/login',
    meta: {
      requiresAuth: false
    },
    children:[
      {
        path: '/home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "home" */ '../views/home/home.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/teaching',
        name: 'AdaptiveTeaching',
        component: () => import(/* webpackChunkName: "teaching" */ '../views/teaching/AdaptiveTeaching.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/exam-papers',
        name: 'ExamPapers',
        component: () => import(/* webpackChunkName: "teaching" */ '../views/teaching/ExamPapers.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/submit-paper',
        name: 'SubmitPaper',
        component: () => import(/* webpackChunkName: "teaching" */ '../views/teaching/SubmitPaper.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/analysis',
        name: 'IntelligentAnalysis',
        component: () => import(/* webpackChunkName: "analysis" */ '../views/analysis/IntelligentAnalysis.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/history-papers',
        name: 'HistoryPapers',
        component: () => import(/* webpackChunkName: "analysis" */ '../views/analysis/HistoryPapers.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/answer-sheet',
        name: 'AnswerSheetView',
        component: () => import(/* webpackChunkName: "analysis" */ '../views/analysis/AnswerSheetView.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/intelligent-test',
        name: 'IntelligentTest',
        component: () => import(/* webpackChunkName: "test" */ '../views/test/IntelligentTest.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/students',
        name: 'StudentManagement',
        component: () => import(/* webpackChunkName: "students" */ '../views/students/StudentManagement.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/students/new',
        name: 'StudentForm',
        component: () => import(/* webpackChunkName: "students" */ '../views/students/StudentForm.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/students/edit/:aid',
        name: 'StudentFormEdit',
        component: () => import(/* webpackChunkName: "students" */ '../views/students/StudentForm.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/schools',
        name: 'SchoolManagement',
        component: () => import(/* webpackChunkName: "schools" */ '../views/schools/SchoolManagement.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/schools/new',
        name: 'SchoolForm',
        component: () => import(/* webpackChunkName: "schools" */ '../views/schools/SchoolForm.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/schools/edit/:aid',
        name: 'SchoolFormEdit',
        component: () => import(/* webpackChunkName: "schools" */ '../views/schools/SchoolForm.vue'),
        meta: {
          requiresAuth: false
        }
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
        meta: {
          requiresAuth: false
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = store.getters['user/isLogin']
  
  if (to.meta.requiresAuth && !isLogin) {
    // 需要登录但未登录，跳转到登录页
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

export default router

